<template>
  <div class="big offline-activities">
    <div class="page_title">线下活动</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="top-header">
          <div class="search-box">
            <!-- 活动名称 -->
            <div class="item">
              <span>活动名称</span>
              <div class="item-content">
                <el-input
                  v-model="searchForm.act_name"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>

            <!-- 状态 -->
            <div class="item" style="margin-left: 10px">
              <span>状态</span>
              <div class="item-content">
                <el-select
                  v-model="searchForm.act_status"
                  clearable
                  size="small"
                  placeholder="请选择"
                  @change="seachEnterFun"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
            </div>
          </div>
          <!-- 添加券包 -->
          <div style="margin-bottom: 10px">
            <el-button
              type="primary"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('2000') : false
              "
              @click="addOrEditBtn(-1, -1)"
              >添加活动</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateTimeFormat }}
                </div>

                <div v-else-if="item.prop == 'act_status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>

                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="140"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="openLink(scope.row)"
                  >链接</el-button
                >

                <el-button
                  type="text"
                  @click="addOrEditBtn(scope.row.act_id, scope.row.act_status)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1999')
                      : false
                  "
                  >详情</el-button
                >
                <el-button
                  type="text"
                  @click="toStatistics(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('2001')
                      : false
                  "
                  >统计</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>

      <!-- 链接 -->
      <el-dialog title="链接" :visible.sync="dialogLink" width="600px">
        <div
          style="
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            font-size: 16px;
          "
        >
          <div style="margin-bottom: 20px">
            小程序路由地址：{{ link_url }}
            <el-button
              type="primary"
              size="small"
              style="margin-left: 10px;margin-top: 10px;"
              @click="copyLink(link_url)"
              >复制</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import activity from "@/api/activity.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      searchForm: {
        act_name: "",
        act_status: "",
      },
      statusOptions: [
        {
          label: "未开始",
          value: 1,
        },
        {
          label: "报名中",
          value: 2,
        },
        {
          label: "报名结束",
          value: 3,
        },
        {
          label: "进行中",
          value: 4,
        },
        {
          label: "已结束",
          value: 5,
        },
      ],
      tableHeader: [
        {
          label: "活动名称",
          prop: "act_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "活动地址",
          prop: "act_address",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "人数",
          prop: "act_num",
          width: "100",
          align: "center",
          fixed: false,
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "300",
          align: "center",
          fixed: false,
        },
        {
          label: "状态",
          prop: "act_status",
          width: "auto",
          align: "center",
          fixed: false,
        },
      ],
      tableData: [],
      dialogLink: false,
      link_url: "",
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "未开始";
        case 2:
          return "报名中";
        case 3:
          return "报名结束";
        case 4:
          return "进行中";
        case 5:
          return "已结束";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.pagination, this.searchForm);
      this.tableLoading = true;
      activity.offlineActivityList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    openLink(row) {
      this.link_url = `/${row.link_url}`;
      this.dialogLink = true;
    },
    copyLink(act_url) {
      let oInput = document.createElement("input");
      oInput.value = act_url;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    toStatistics(row) {
      let { act_id, act_name } = row;
      this.$router.push({
        path: "/home/activity/offlineStatistics",
        query: {
          act_id,
          act_name,
        },
      });
    },
    addOrEditBtn(act_id, status) {
      this.$router.push({
        path: "/home/activity/addOrEdit",
        query: {
          act_id,
          status,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.offline-activities {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
